import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import "react-perfect-scrollbar/dist/css/styles.css";
import "nprogress/nprogress.css";
import "src/assets/css/prism.css";
import React from "react";
import ReactDOM from 'react-dom/client';
import { Provider } from "react-redux";
import { enableES5 } from "immer";
import * as serviceWorker from "src/serviceWorker";
import store from "src/store";
import App from "src/App";

enableES5();

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
      <App />
  </Provider>
);

// The service worker's update/validation logic calls window.location.reload()
// (serviceWorker.js), and dev builds don't emit /service-worker.js, which causes a
// white-screen reload loop in development. Keep the PWA behavior in production only;
// in development unregister so any previously-installed worker is removed.
if (process.env.NODE_ENV === "production") {
  serviceWorker.register();
} else {
  serviceWorker.unregister();
}
